jQuery($ => {
    class MeganavMenu {
      constructor(element) {
        this._                   = element;
        this._element            = $(element);
        this._trigger            = this._element.find('.m-meganav-menu__trigger-input');
        this._wrapper            = this._element.find('.m-meganav-menu__wrapper');
        this._mouseoverDebouncer = null;
        this._openedByClick      = false;
        this._openedTime         = null;

        this._clickOutsideHandler;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('mouseenter', () => this.handleMeganavMouseEnter());
        this._element.on('mouseleave', (e) => this.handleMeganavMouseLeave(e));
        this._trigger.on('change', (e) => this.handleMeganavToggle(e));
      }

      handleMeganavMouseEnter() {
        // Delay the opening event by 300ms
        // This way, if the cursor is just passing over the meganav, it won't open
        // Which was quite a bad experience
        this._mouseoverDebouncer = setTimeout(() => {
          if (window.matchMedia('(hover: hover)').matches && window.matchMedia('(min-width: 950px)').matches) {
            this.handleMeganavOpen();
          }
          
          clearTimeout(this._mouseoverDebouncer);
        }, 300);
      }

      handleMeganavMouseLeave(e) {
        clearTimeout(this._mouseoverDebouncer);
        if (window.matchMedia('(hover: hover)').matches && window.matchMedia('(min-width: 950px)').matches) {
          const target = $(e.relatedTarget);

          // Check if:
          // 1. Target is not inside this._element
          // 2. Target is not inside .o-header
          if (!target.closest(this._element).length && !target.closest('.o-header').length) {
            this.handleMeganavClose();
          }
        }
      }

      handleMeganavToggle(e) {
        // If opened time is less than 500ms ago, dont do anything
        if (Date.now() - this._openedTime < 500) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        clearTimeout(this._mouseoverDebouncer);
        if (e.target.checked) {
          this.handleMeganavOpen(true);
        } else {
          this.handleMeganavClose(true);
        }
      }

      handleMeganavOpen(wasOpenedByClick = false) {
        // If meganav was hovered but checkbox is checked, don't do anything
        if (!wasOpenedByClick && this._trigger.prop('checked')) {
          return;
        }

        this._wrapper.show();

        this._openedByClick = wasOpenedByClick;
        this._openedTime = Date.now();

        $('.o-header').addClass('o-header--meganav-open');

        // If trigger is still unchecked, check it
        if (!this._trigger.prop('checked')) {
          this._trigger.prop('checked', true);
        }

        this._element.addClass('m-meganav-menu--open');

        // Are there other meganavs open?
        if ($('.m-meganav-menu--open').length > 1) {
          // Add special class to this meganav so that it doesn't fully animate
          this._element.addClass('m-meganav-menu--open--no-animate');

          $('.m-meganav-menu--open').each((_, meganav) => {
            if (meganav !== this._element[0]) {
              $(meganav).removeClass('m-meganav-menu--open');
              $(meganav).removeClass('m-meganav-menu--open--no-animate');
              setTimeout(() => {
                $(meganav).find('.m-meganav-menu__wrapper').hide();
              }, 250);
              const checkbox = $(meganav).find('.m-meganav-menu__trigger-input');
              $(checkbox).prop('checked', false);
            }
          });
        }

        setTimeout(() => {
          $('body').on('click', this.handleClickOutside);
        }, 0);
      }

      handleClickOutside = (e) => {
        const target = $(e.target);
        // Check if target is within this._element
        if (!target.closest(this._element).length) {
          this.handleMeganavClose(true);
        };
      }

      handleMeganavClose(wasClosedByClick = false) {
        if (this._openedByClick && !wasClosedByClick) {
          return;
        }

        this.unregisterClickOutside();
        this._element.removeClass('m-meganav-menu--open');
        setTimeout(() => {
          this._wrapper.hide();
        }, 250);
        
        // If trigger is still checked, uncheck it
        if (this._trigger.prop('checked')) {
          this._trigger.prop('checked', false);
        }

        // Close header if no meganavs are open
        if ($('.m-meganav-menu--open').length <= 0) {          
          $('.o-header').removeClass('o-header--meganav-open');
        }

      }

      unregisterClickOutside() {
        $('body').off('click', this.handleClickOutside);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.meganav_menu = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].meganav_menu = new MeganavMenu(_[i], opt);
        else
          ret = _[i].meganav_menu[opt].apply(_[i].meganav_menu, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-meganav-menu').meganav_menu();
});